import React from 'react';

const TypingIndicator = ({ message = "HealthOps is analyzing..." }) => {
  return (
    <div className="flex justify-start animate-fade-in">
      <div className="flex items-start space-x-3">
        <div className="w-8 h-8 bg-gradient-to-br from-[#831f82] to-[#6b1a6b] rounded-full flex items-center justify-center text-white text-sm">
          🤖
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-2xl rounded-bl-md shadow-sm">
          <div className="flex items-center space-x-3">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-[#831f82] rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-[#831f82] rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2 h-2 bg-[#831f82] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
            <span className="text-gray-600 text-sm">{message}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;